import { Box3, Vector3 } from 'three';

interface ParsedGCode {
  rapidMovePoints: Vector3[];
  linearMovePoints: Vector3[];
}

enum GCodeUnit {
  inches = 'inches',
  mm = 'mm',
}

export function parseGCode(gcode: string): ParsedGCode {
  const lines = gcode.split('\n');
  const rapidMovePoints: Vector3[] = [];
  const linearMovePoints: Vector3[] = [];
  let x = 0;
  let y = 0;
  let z = 0;

  let currentPoints = linearMovePoints; // Default to G1 moves

  lines.forEach((line) => {
    if (line.startsWith('G0')) {
      currentPoints = rapidMovePoints;
    } else if (line.startsWith('G1')) {
      currentPoints = linearMovePoints;
    }

    const matchX = line.match(/X(-?\d+(\.\d+)?)/);
    const matchY = line.match(/Y(-?\d+(\.\d+)?)/);
    const matchZ = line.match(/Z(-?\d+(\.\d+)?)/);

    if (matchX) x = parseFloat(matchX[1]);
    if (matchY) y = parseFloat(matchY[1]);
    if (matchZ) z = parseFloat(matchZ[1]);

    currentPoints.push(new Vector3(x, y, z));
  });

  return { rapidMovePoints, linearMovePoints };
}

export function getGcodeUnit(gcode: string): GCodeUnit {
  if (gcode.includes('G20')) {
    return GCodeUnit.inches;
  }
  if (gcode.includes('G21')) {
    return GCodeUnit.mm;
  }
  return GCodeUnit.mm;
}

export function calculateBoundingBox(points: Vector3[]): Box3 | null {
  if (points.length === 0) {
    return null;
  }

  const box = new Box3().setFromPoints(points);
  return box;
}

export function centerPoints(
  points: Vector3[],
  boundingBox: Box3 | null
): Vector3[] {
  if (!boundingBox) return points;

  const center = new Vector3();
  boundingBox.getCenter(center);

  return points.map((point) => point.clone().sub(center));
}
